import { Routes } from '@angular/router';

import { DashboardComponent } from '../app/modules/dashboard/dashboard.component';

import { ItemMasterComponent } from '../app/modules/item-master/item-master.component';

import { AssetRegisterComponent } from '../app/modules/asset-register/asset-register.component';

import { CurrentStockComponent } from '../app/modules/current-stock/current-stock.component';

import { GoodsReceivedComponent } from '../app/modules/goods-received/goods-received.component';

import { IssueStockComponent } from '../app/modules/issue-stock/issue-stock.component';

import { IssuedStockComponent } from '../app/modules/issued-stock/issued-stock.component';

import { ItemHistoryComponent } from '../app/modules/item-history/item-history.component';

import { StockTransferComponent } from '../app/modules/stock-transfer/stock-transfer.component';

import { CheckOutComponent } from './check-out/check-out.component';

import { ReservationsComponent } from './reservations/reservations.component';

import { DamagedComponent } from './damaged/damaged.component';

import { MaitenanceJobsComponent } from '../app/modules/maitenance-jobs/maitenance-jobs.component';

import { RepairHistoryComponent } from '../app/modules/repair-history/repair-history.component';

import { ReportsComponent } from '../app/modules/Reports/reports.component';

import { StockOnHandReportComponent } from '../app/modules/stock-on-hand/stock-on-hand.component';

import { LowStockReportComponent } from '../app/modules/low-stock/low-stock.component';

import { StockMovementReportComponent } from '../app/modules/stock-movement/stock-movement.component';

import { FuneralUsageReportComponent } from '../app/modules/funeral-usage/funeral-usage.component';

import { CheckedOutEquipmentReportComponent } from '../app/modules/checked-out-equipment/checked-out-equipment.component';

import { OverdueReturnsReportComponent } from '../app/modules/overdue-returns-report/overdue-returns-report.component';

import { DamagedEquipmentReportComponent } from '../app/modules/damaged-equipment/damaged-equipment.component';

import { StockValuationReportComponent } from '../app/modules/stock-valuation/stock-valuation.component';

import { LoginPageComponent } from '../app/modules/login-page/login-page.component';

import { OtpPageComponent } from '../app/modules/otp-page/otp-page.component';

import {
  authGuard,
  otpGuard,
  permissionGuard,
  resetPasswordGuard,
} from '../app/modules/auth/auth.guard';

import { ForgotPasswordComponent } from '../app/modules/forgot-password/forgot-password.component';

import { ResetPasswordComponent } from '../app/modules/reset-password/reset-password.component';

import { UserPermissionsComponent } from '../app/modules/user-permissions/user-permissions.component';

import { BranchesComponent } from '../app/modules/branches/branches.component';

import { LocationsComponent } from '../app/modules/locations/locations.component';

import { CategoriesComponent } from '../app/modules/categories/categories.component';

import { UnitsOfMeasureComponent } from '../app/modules/units-of-measure/units-of-measure.component';

import { SuppliersComponent } from '../app/modules/suppliers/suppliers.component';
import { CheckInComponent } from './check-in/check-in.component';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },

  { path: 'login', component: LoginPageComponent, title: 'Sign In' },

  {
    path: 'otp',
    component: OtpPageComponent,
    canActivate: [otpGuard],
    title: 'Verify Code',
  },

  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [authGuard],
    title: 'Dashboard',
  },

  {
    path: 'item-master',
    component: ItemMasterComponent,
    canActivate: [authGuard],
    title: 'Register Items',
  },

  {
    path: 'asset-register',
    component: AssetRegisterComponent,
    canActivate: [authGuard],
    title: 'Register Items',
  },

  {
    path: 'current-stock',
    component: CurrentStockComponent,
    canActivate: [authGuard],
    title: 'Current Stock',
  },

  {
    path: 'goods-received',
    component: GoodsReceivedComponent,
    canActivate: [authGuard],
    title: 'Goods Received',
  },

  {
    path: 'issue-stock',
    component: IssueStockComponent,
    canActivate: [authGuard],
    title: 'Issue Stock',
  },

  {
    path: 'issued-stock',
    component: IssuedStockComponent,
    canActivate: [authGuard],
    title: 'Issued Stock',
  },

  {
    path: 'item-history',
    component: ItemHistoryComponent,
    canActivate: [authGuard],
    title: 'Track Item',
  },

  {
    path: 'item-history/:itemId',
    component: ItemHistoryComponent,
    canActivate: [authGuard],
    title: 'Track Item',
  },

  {
    path: 'stock-transfers',
    component: StockTransferComponent,
    canActivate: [authGuard],
    title: 'Stock Transfers',
  },

  {
    path: 'reservations',
    component: ReservationsComponent,
    canActivate: [authGuard],
    title: 'Reservations',
  },

  {
    path: 'check-out',
    component: CheckOutComponent,
    canActivate: [authGuard],
    title: 'Check Out',
  },

  {
    path: 'check-in',
    component: CheckInComponent,
    canActivate: [authGuard],
    title: 'Check In',
  },

  { path: 'overdue-returns', redirectTo: 'check-in', pathMatch: 'full' },

  {
    path: 'damaged',
    component: DamagedComponent,
    canActivate: [authGuard],
    title: 'Damaged Items',
  },

  {
    path: 'damaged-lost',
    component: DamagedComponent,
    canActivate: [authGuard],
    title: 'Damaged Items',
  },

  {
    path: 'maintenance-jobs',
    component: MaitenanceJobsComponent,
    canActivate: [authGuard],
    title: 'Maintenance Jobs',
  },

  {
    path: 'repair-history',
    component: RepairHistoryComponent,
    canActivate: [authGuard],
    title: 'Repair History',
  },

  {
    path: 'reports',
    component: ReportsComponent,
    canActivate: [authGuard, permissionGuard],
    data: { navArea: 'reports' },
    title: 'Reports',
  },

  {
    path: 'stock-on-hand',
    component: StockOnHandReportComponent,
    canActivate: [authGuard, permissionGuard],
    data: { navArea: 'reports' },
    title: 'Stock on Hand',
  },

  {
    path: 'low-stock',
    component: LowStockReportComponent,
    canActivate: [authGuard, permissionGuard],
    data: { navArea: 'reports' },
    title: 'Low Stock',
  },

  {
    path: 'stock-movement',
    component: StockMovementReportComponent,
    canActivate: [authGuard, permissionGuard],
    data: { navArea: 'reports' },
    title: 'Stock Movement',
  },

  {
    path: 'case-usage',
    component: FuneralUsageReportComponent,
    canActivate: [authGuard, permissionGuard],
    data: { navArea: 'reports' },
    title: 'Case / Job Usage',
  },

  { path: 'funeral-usage', redirectTo: 'case-usage', pathMatch: 'full' },

  {
    path: 'checked-out-equipment',
    component: CheckedOutEquipmentReportComponent,
    canActivate: [authGuard, permissionGuard],
    data: { navArea: 'reports' },
    title: 'Checked-Out Items',
  },

  {
    path: 'overdue-returns-report',
    component: OverdueReturnsReportComponent,
    canActivate: [authGuard, permissionGuard],
    data: { navArea: 'reports' },
    title: 'Overdue Returns Report',
  },

  {
    path: 'damaged-equipment',
    component: DamagedEquipmentReportComponent,
    canActivate: [authGuard, permissionGuard],
    data: { navArea: 'reports' },
    title: 'Damaged Items Report',
  },

  {
    path: 'stock-valuation',
    component: StockValuationReportComponent,
    canActivate: [authGuard, permissionGuard],
    data: { navArea: 'reports' },
    title: 'Stock Valuation',
  },

  {
    path: 'branches',
    component: BranchesComponent,
    canActivate: [authGuard, permissionGuard],
    data: { entity: 'branches', navArea: 'settings' },
    title: 'Branches',
  },

  {
    path: 'locations',
    component: LocationsComponent,
    canActivate: [authGuard, permissionGuard],
    data: { entity: 'locations', navArea: 'settings' },
    title: 'Locations',
  },

  {
    path: 'categories',
    component: CategoriesComponent,
    canActivate: [authGuard, permissionGuard],
    data: { entity: 'categories', navArea: 'settings' },
    title: 'Categories',
  },

  {
    path: 'units-of-measure',
    component: UnitsOfMeasureComponent,
    canActivate: [authGuard, permissionGuard],
    data: { entity: 'units', navArea: 'settings' },
    title: 'Units of Measure',
  },

  {
    path: 'suppliers',
    component: SuppliersComponent,
    canActivate: [authGuard, permissionGuard],
    data: { entity: 'suppliers', navArea: 'settings' },
    title: 'Suppliers',
  },

  {
    path: 'user-permissions',
    component: UserPermissionsComponent,
    canActivate: [authGuard, permissionGuard],
    data: { entity: 'users', navArea: 'users' },
    title: 'User Permissions',
  },

  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    title: 'Forgot Password',
  },

  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    canActivate: [resetPasswordGuard],
    title: 'Reset Password',
  },

  { path: '**', redirectTo: 'login' },
];
